var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGestureSwipeLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.50003C22 4.77617 21.7761 5.00003 21.5 5.00003H16V5.94003C15.9686 6.12748 15.8356 6.28192 15.6549 6.34076C15.4741 6.3996 15.2757 6.35307 15.14 6.22003L13.14 4.17003C13.0685 4.10039 13.0282 4.00482 13.0282 3.90503C13.0282 3.80524 13.0685 3.70967 13.14 3.64003L15.14 1.64003C15.2866 1.5016 15.501 1.46256 15.687 1.54042C15.873 1.61828 15.9957 1.79843 16 2.00003V3.00003H21.5C21.7761 3.00003 22 3.22389 22 3.50003V4.50003ZM18 14.74V14.47C17.9896 13.6717 17.6707 12.9084 17.11 12.34L14.38 9.62003C13.8155 9.05481 13.0488 8.73807 12.25 8.74003H9.99997V10.5C9.99997 10.7762 9.77612 11 9.49997 11C9.22383 11 8.99997 10.7762 8.99997 10.5V4.00003C8.99997 3.44775 8.55226 3.00003 7.99997 3.00003C7.44769 3.00003 6.99997 3.44775 6.99997 4.00003V15L4.10997 12.15C3.59053 11.6599 2.7999 11.5974 2.20997 12C1.98739 12.1626 1.93424 12.4726 2.08997 12.7L3.59997 14.85C4.13179 15.6117 4.41579 16.4099 4.69001 17.1806C5.02423 18.12 5.3439 19.0185 6.07997 19.76L8.45997 22.09C9.02204 22.6528 9.78459 22.9693 10.58 22.97H13.17C13.9654 22.9693 14.7279 22.6528 15.29 22.09C16.008 21.3695 16.531 20.4783 16.81 19.5L17.81 16.11C17.9382 15.6647 18.0021 15.2034 18 14.74Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGestureSwipeLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gesture_swipe_left.b275dbf5.svg";
export { ForwardRef as ReactComponent };